import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Tier } from '../../models/tier';
import { TiersService } from '../services/tiers.service';

@Injectable()
export class TierResolver implements Resolve<Tier>
{
	private tiersService: TiersService;

	constructor(tiersService: TiersService)
	{
		this.tiersService = tiersService;
	}

	resolve(route: ActivatedRouteSnapshot): Promise<Tier>
	{
		return this.tiersService.getTierById(+route.params['id']);
	}
}



// WEBPACK FOOTER //
// ./src/app/tiers/resolvers/tier.resolver.ts